import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM, TOP } from 'Component/ChevronIcon/ChevronIcon.config';
import {
    ExpandableContent as SourceExpandableContent
} from 'SourceComponent/ExpandableContent/ExpandableContent.component';

/** @namespace Bodypwa/Component/ExpandableContent/Component */
export class ExpandableContentComponent extends SourceExpandableContent {
    /* eslint-disable */
    componentDidUpdate() {
        const { forceClose, currentExpanded, accordeon, device: { isMobile } } = this.props;

        if(forceClose) {
            this.setState({
                isContentExpanded: false
            });
        }
        if (accordeon && !isMobile) {
            const isContentExpanded = currentExpanded === this.expandableContentRef;
            this.setState({
                isContentExpanded
            });
        }
    }
    /* eslint-disable */

    static defaultProps = {
        heading: '',
        isContentExpanded: false,
        onClick: null,
        children: [],
        isArrow: false,
        mods: {},
        accordeon: false,
        closeExpanded: () => false,
        currentExpanded: null
    };

    renderButtonIcon() {
        const { isContentExpanded } = this.state;
        const { isArrow } = this.props;
        if (isArrow) {
            return <ChevronIcon direction={ isContentExpanded ? TOP : BOTTOM } />;
        }

        return this.renderTogglePlusMinus();
    }

    toggleExpand = () => {
        const { onClick, closeExpanded } = this.props;
        if (onClick) {
            onClick();

            return;
        }

        closeExpanded(!this.state.isContentExpanded, this.expandableContentRef);
        this.setState(
            ({ isContentExpanded }) => ({ isContentExpanded: !isContentExpanded }),
            () => this.scrollToExpandedContent()
        );
    };
}

export default ExpandableContentComponent;
